<template>
  <Breadcrumbs main="Event" title="upload successful" />
  <div class="container-fluid">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-body">
          <div class="d-flex justify-content-center">
            <img
              style="width: 50%; border-radius: 0.5rem"
              :src="this.eventDetails.coverurl"
              alt="Event Cover"
            />
          </div>
          <p></p>
          <div class="d-flex justify-content-center">
            <b>{{ this.eventDetails.title }}</b>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-header">
          <div class="upload-header-top">
            <b class="m-0 upload-header-title">
              <b
                >upload successful sorted by taken date
                {{ this.image_length }} items</b
              >
            </b>
            <div class="upload-header-actions">
            <button
              type="button"
              @click.prevent="getUploadImages('TAGGING')"
              class="btn btn-sm upload-action-btn upload-action-btn-primary"
            >
              <vue-feather type="filter" size="13"> </vue-feather> filter wait
              for tagging
            </button>
            <button
              type="button"
              @click.prevent="getUploadImages()"
              class="btn btn-sm upload-action-btn upload-action-btn-primary"
            >
              <vue-feather type="refresh-cw" size="13"> </vue-feather> all
            </button>
            <button
              type="button"
              @click.prevent="downloadFileNameListTxt"
              class="btn btn-sm upload-action-btn upload-action-btn-secondary"
            >
              <vue-feather type="download" size="13"> </vue-feather>
              download file name .txt
            </button>
            </div>
          </div>
          <div class="col-sm-12 upload-type-row">
            <b>type: </b>&nbsp;&nbsp;
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                @change.prevent="update_event_coupon"
                v-model="is_type"
                required
                type="radio"
                name="inlineRadioOptions"
                id="inlineRadio1"
                value="NAME"
              />
              <label class="form-check-label" for="inlineRadio1"> name </label>
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                @change.prevent="update_event_coupon"
                v-model="is_type"
                type="radio"
                required
                name="inlineRadioOptions"
                id="inlineRadio2"
                value="NAMEPLUS"
              />
              <label class="form-check-label" for="inlineRadio2">
                name and image
              </label>
            </div>
          </div>
        </div>

        <div
          class="my-gallery card-body row gallery-with-description"
          v-if="this.is_type === 'NAME'"
        >
          <div
            class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12"
            v-for="(file, index) in this.image_uploaded"
            :key="index"
          >
            <p v-if="file.tag === 1" class="success" style="font-size: x-small">
              {{ file.original_file_name }}[completed]
            </p>
            <span v-else class="uploading" style="font-size: x-small">
              {{ file.original_file_name }}[tagging]
              <div class="progress-bar-wrapper"></div>
            </span>
          </div>
        </div>

        <div class="card-body" v-if="this.is_type === 'NAMEPLUS'">
          <div class="container-fluid">
            <div>
              <figure
                v-for="(src, index) in displayed_images"
                :key="src.id || index"
              >
                <div class="gallery gellerycont">
                  <img
                    @click.stop="copySrcId(src.id)"
                    :id="src.id"
                    :src="this.s3_url + '/' + src.thumbnail_file_name"
                    :alt="src.original_file_name"
                    loading="lazy"
                  />

                  <label class="btn" style="font-size: xx-small;" :for="src.id">
                    ID: <span ref="srcIdText">{{ src.id }}</span>
                    <br />
                    NAME: {{ src.original_file_name }}
                  </label>
                </div>
              </figure>
              <div style="clear: both"></div>
            </div>

            <div ref="sentinel" style="height: 1px; margin-top: 50px"></div>

            <div
              v-if="loading_more"
              class="loading-indicator text-center mt-3 mb-3"
            >
              <img
                style="align-items: center; width: 30px"
                src="../../assets/images/running_loading.svg"
                alt="Loading Spinner"
              />
            </div>
          </div>
        </div>
        <div class="row" v-if="this.is_loading === 'Y' && !loading_more">
          <p>&nbsp;</p>
          <div class="d-flex justify-content-center">
            <img
              style="align-items: center; width: 30px"
              src="../../assets/images/running_loading.svg"
              alt="Loading Spinner"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// (ส่วน script เหมือนเดิม ไม่มีการเปลี่ยนแปลงในส่วนนี้)
import axios from "axios";
// import Breadcrumbs from '@/components/common/breadcrumbs';
// import VueFeather from 'vue-feather';

export default {
  // components: { Breadcrumbs, VueFeather },
  data() {
    return {
      eventDetails: {},
      all_images: [],
      displayed_images: [],
      image_length: 0,
      images_per_load: 200,
      loading_more: false,
      is_loading: "",
      event_id: "",
      event_key: this.$route.params.q,
      s3_url: process.env.VUE_APP_AWS_S3_URL,
      is_type: "NAME", // ค่าเริ่มต้น
      observer: null,
    };
  },
  async created() {
    this.is_loading = "Y";
    let eventDetail = await this.getEventDetail(this.$route.params.q);
    this.event_id = eventDetail.event_id;

    await this.fetchAllUploadedImages();

    this.is_loading = "N";

    this.$nextTick(() => {
      if (this.is_type === "NAMEPLUS") {
        this.setupIntersectionObserver();
      }
    });
  },
  watch: {
    is_type(newVal, oldVal) {
      if (newVal === "NAMEPLUS") {
        this.loadInitialImages();
        this.$nextTick(() => {
          this.setupIntersectionObserver();
        });
      } else {
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
      }
    },
    displayed_images() {
      this.$nextTick(() => {
        if (
          this.is_type === "NAMEPLUS" &&
          this.displayed_images.length < this.all_images.length
        ) {
          this.setupIntersectionObserver();
        }
      });
    },
  },
  methods: {
    async copySrcId(id) {
      try {
        await navigator.clipboard.writeText(id);
      } catch (err) {
        console.error("Failed to copy ID: ", err);
        alert("Failed to copy ID.");
      }
    },

    async getEventDetail(event_key) {
      const res = await axios.get("/v1/events/" + event_key);
      if (res.data.status === "success") {
        this.eventDetails = res.data;
        this.eventPackage = res.data.package;
        return res.data;
      } else {
        alert(
          "[event] An error has occurred. Please contact the system administrator!"
        );
        this.$router.push({ path: "/" });
      }
    },

    async fetchAllUploadedImages(_filter = null) {
      this.is_loading = "Y";
      this.all_images = [];
      this.displayed_images = [];
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      const data = {
        event_id: this.event_id,
        filter: _filter,
      };
      const headers = {
        Authorization: "Bearer " + localStorage.getItem("jwt"),
      };

      try {
        const response = await axios.post("v1/image/uploaded", data, {
          headers,
        });

        if (response.data.status === "success") {
          this.all_images = response.data.body;
          this.image_length = response.data.count;

          if (this.is_type === "NAMEPLUS") {
            this.loadInitialImages();
            this.$nextTick(() => {
              this.setupIntersectionObserver();
            });
          } else {
            this.image_uploaded = response.data.body;
          }
        } else {
          alert(
            "[upload-images] An error has occurred. Please contact the system administrator!"
          );
          this.$router.push({ path: "/" });
        }
      } catch (error) {
        console.error("Error fetching uploaded images:", error);
        alert("Failed to load images. Please try again.");
      } finally {
        this.is_loading = "N";
      }
    },

    loadInitialImages() {
      if (this.all_images && this.all_images.length > 0) {
        this.displayed_images = this.all_images.slice(0, this.images_per_load);
      } else {
        this.displayed_images = [];
      }
    },

    async loadMoreImages() {
      if (
        this.loading_more ||
        this.displayed_images.length === this.all_images.length
      ) {
        return;
      }

      this.loading_more = true;
      const startIndex = this.displayed_images.length;
      const endIndex = startIndex + this.images_per_load;
      const newImages = this.all_images.slice(startIndex, endIndex);

      await new Promise((resolve) => setTimeout(resolve, 300));

      this.displayed_images = [...this.displayed_images, ...newImages];
      this.loading_more = false;

      this.$nextTick(() => {
        if (
          this.is_type === "NAMEPLUS" &&
          this.displayed_images.length < this.all_images.length
        ) {
          this.setupIntersectionObserver();
        }
      });
    },

    setupIntersectionObserver() {
      const sentinel = this.$refs.sentinel;
      if (!sentinel) {
        console.warn("Sentinel element not found for Intersection Observer.");
        return;
      }

      if (this.observer) {
        this.observer.disconnect();
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (
              entry.isIntersecting &&
              !this.loading_more &&
              this.displayed_images.length < this.all_images.length
            ) {
              this.loadMoreImages();
            }
          });
        },
        {
          rootMargin: "0px 0px 300px 0px",
          threshold: 0.1,
        }
      );

      this.observer.observe(sentinel);
    },

    async update_event_coupon() {
      await this.fetchAllUploadedImages(
        this.is_type === "TAGGING" ? "TAGGING" : null
      );
    },

    async getUploadImages(_filter = null) {
      await this.fetchAllUploadedImages(_filter);
    },

    downloadFileNameListTxt() {
      const sourceList = Array.isArray(this.all_images) ? this.all_images : [];
      if (sourceList.length === 0) {
        alert("ไม่พบข้อมูลไฟล์สำหรับดาวน์โหลด");
        return;
      }

      const fileNames = sourceList
        .map((file) => file.original_file_name || file.thumbnail_file_name || file.id)
        .filter(Boolean);

      if (fileNames.length === 0) {
        alert("ไม่พบชื่อไฟล์สำหรับดาวน์โหลด");
        return;
      }

      const title = this.eventDetails && this.eventDetails.title ? this.eventDetails.title : "event";
      const safeTitle = String(title)
        .trim()
        .replace(/[\\/:*?"<>|]/g, "-")
        .replace(/\s+/g, "_");
      const textContent = fileNames.join("\n");
      const blob = new Blob([textContent], { type: "text/plain;charset=utf-8" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${safeTitle || "event"}_file_names.txt`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
  },
  beforeUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
};
</script>

<style scoped lang="scss">
// CSS เกือบทั้งหมดเหมือนเดิม แต่เพิ่มและปรับบางส่วนเพื่อควบคุมตำแหน่ง
#selectBtn {
  display: none;
}
// .copy-button {
//   position: absolute;
//   top: 5px;
//   right: 5px;
//   background-color: rgba(0, 0, 0, 0.6);
//   color: white;
//   border: none;
//   padding: 5px 8px;
//   border-radius: 3px;
//   cursor: pointer;
//   font-size: 0.8em;
//   line-height: 1;
//   opacity: 0.8;
//   transition: opacity 0.2s ease-in-out;
//   visibility: hidden;
//   opacity: 0;
// }

.gellerycont:hover .copy-button {
  visibility: visible;
  opacity: 0.8;
}

.copy-button:hover {
  opacity: 1;
  background-color: rgba(0, 0, 0, 1);
}

.copy-button i {
  margin-right: 6px;
}
.progress-bar-wrapper {
  height: 3px;
  background-color: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 2px;
}
div.gellerycont:hover {
  cursor: pointer;
  opacity: 0.9;
}
@media screen and (min-width: 451px) and (max-width: 9000px) {
  div.gellerycont {
    margin: 0.5%;
    float: left;
    width: 200px;
    height: 200px;
    min-height: 200px;
    max-height: 200px;
    max-width: 200px;
  }

  div.gellerycont img {
    position: relative;
    width: 200px;
    height: 200px;
    min-height: 200px;
    max-height: 200px;
    padding: 1px;
    max-width: 200px;
    object-fit: contain;
    background: #f7f9fc;
  }
}

@media (min-width: 300px) and (max-width: 450px) {
  div.gellerycont {
    width: 200px;
    height: 200px;
    min-height: 200px;
    max-height: 200px;
    float: left;
    margin: 0.35rem;
    border: none;
    padding: 0;
    box-sizing: border-box;
  }

  div.gellerycont img {
    width: 200px;
    height: 200px;
    object-fit: contain;
    background: #f7f9fc;
    padding: 0;
  }
}

.gellerycont {
  position: relative;
  width: 200px;
  height: 200px;
}

.gellerycont img {
  height: 200px;
  width: 200px;
  object-fit: contain;
  background: #f7f9fc;
}

.gellerycont .btn {
  position: absolute;
  top: 85%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  width: calc(100% - 12px);
  padding: 0.35rem 0.45rem;
  background-color: rgba(0, 0, 0, 0.72);
  color: #ffffff;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.25;
  border-radius: 6px;
  text-align: left;
  white-space: normal;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.45);
}
.card-btn-upload {
  text-align: center;
}
.card-file-list {
  text-align: center;
}

.upload-item {
  border: 1px solid rgb(197, 197, 197);
  border-radius: 0.5rem;
  float: left;
  padding: 1px;
  text-align: center;
}
.drop-container:hover {
  background: #979696ad;
}
.upload-item:hover {
  background: #e0e0e0ad;
  cursor: pointer;
  border: 1px dashed rgba(124, 2, 2, 0.616);
}

.buttons {
  display: flex;
  gap: 1rem;

  &.centered {
    justify-content: center;
  }
}

.button {
  cursor: pointer;
  color: white;
  background: #809af0;
  text-decoration: none;
  width: fit-content;
  padding: 0.5rem 1rem;
  border-radius: 2px;

  &:hover {
    background: #3f6cff;
  }

  &.disabled {
    cursor: default;
    background: lightgray;
    pointer-events: none;
  }
}

.button-danger {
  background: #f08080;

  &:hover {
    background: #f65959;
  }
}

.button-upload {
  background: #00d591;

  &:hover {
    background: #02b97f;
  }
}

.failed {
  color: red;
  font-size: x-small;
}

.success {
  color: green;
}

.uploading {
  color: rgb(255, 102, 0);
  font-size: x-small;
}

.failed-border {
  border-color: red;
  font-size: x-small;
}

/* **CSS เพิ่มเติมสำหรับการจัดตำแหน่ง** */
.image-gallery-wrapper {
  // เพิ่มการเคลียร์ float ที่นี่ เพื่อให้ element ที่อยู่ข้างใต้ไม่ถูก float กระทบ
  overflow: inherit; // หรือใช้ display: flow-root;
}

.loading-indicator {
  // ถ้าใช้ float: left กับ gellerycont มันจะทำให้ text-align: center ไม่ทำงาน
  // ต้องให้ element นี้เป็น block-level และไม่ถูก float ของรูปภาพกระทบ
  // การใช้ clear: both; จะช่วยให้มันขึ้นบรรทัดใหม่หลังรูปภาพที่ float
  clear: both;
  width: 100%; // ให้กินพื้นที่เต็มความกว้างของ parent
  text-align: center; // จัดกลาง
  padding: 10px 0; // เพิ่ม padding
}

.upload-header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-bottom: 0.6rem;
}

.upload-header-title {
  color: #243f68;
}

.upload-header-actions {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.upload-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  border-radius: 999px;
  padding: 0.34rem 0.78rem;
  font-weight: 600;
  border: none;
}

.upload-action-btn-primary {
  color: #fff;
  background: linear-gradient(135deg, #389dff 0%, #2d74ea 100%);
  box-shadow: 0 5px 14px rgba(45, 116, 234, 0.22);
}

.upload-action-btn-primary:hover {
  color: #fff;
  background: linear-gradient(135deg, #2f92f2 0%, #235fc3 100%);
}

.upload-action-btn-secondary {
  color: #2d4b75;
  background: #eef3fb;
  border: 1px solid #d7e4f6;
}

.upload-action-btn-secondary:hover {
  color: #1f3e68;
  background: #e5eefb;
}

.upload-type-row {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  flex-wrap: wrap;
}
</style>